
export function sortObjectArray(data: Array<any>, sortByKeys: Array<string>) {
    const sortByKeys2 = sortByKeys.map((key: string) => {
        const obj = { key }
        return obj;
    });
    sortObjectArrayPro(data, sortByKeys2);
}

export function sortObjectArrayPro(data: Array<any>, sortByKeys: Array<any>) {
    const compare = (a: any, b: any, i = 0): number => {
        if (sortByKeys[i]) {
            const k = sortByKeys[i].key;
            const desc = sortByKeys[i].desc;
            const ak = a[k] || '', bk = b[k] || '';
            // console.log(k, ak, bk);
            // 1. Leer ist am größsten.
            if (!ak && bk) {
                if (desc) {
                    return -1;
                }
                return 1;
            } else if (ak && !bk) {
                if (desc) {
                    return 1;
                }
                return -1;
            }
            // 2. Im Vergleich
            if (ak > bk) {
                if (desc) {
                    return -1;
                }
                return 1;
            } else if (ak < bk) {
                if (desc) {
                    return 1;
                }
                return -1;
            }
            return compare(a, b, i + 1);
        }
        return 0;
    };
    data.sort((a: any, b: any) => compare(a, b));
}
